import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import './tour.css';
import { Autoplay, Pagination } from 'swiper/modules';

function C2wTour() {
  const images = [
    "Image26.png",
    "Image1.jpeg",
    "Image2.jpeg",
    "Image25.png"
  ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const len = images.length;

  return (
    <div className="C2wTourPage_ctn_redesign">
      {/* Badge Pill */}
      <div className="C2wTourPage_badge">
        <span className="badge-icon-circle-blue">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
          </svg>
        </span>
        <span>Our Gallery</span>
      </div>

      {/* Heading */}
      <h2 className="C2wTourPage_heading">
        A Visual Tour Of Our <span className="highlight-blue-gradient">Institute</span>
      </h2>

      {/* Slider Wrapper */}
      <div className="C2wTourPage_carousel_wrapper">
        <Swiper
          modules={[Autoplay, Pagination]}
          loop={true}
          spaceBetween={30}
          speed={1000}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          }}
          className="C2wTourPage_swiper"
        >
          {images.map((centerImg, idx) => {
            const verticalImg = images[(idx + 1) % len];
            const bottomImg = images[(idx + 2) % len];
            const smallImg = images[(idx + 3) % len];

            return (
              <SwiperSlide key={idx}>
                {windowWidth > 768 ? (
                  /* Desktop Layout: Collage with Center Active Card */
                  <div className="gallery-slide-layout">
                    {/* Left Collage */}
                    <div className="gallery-side-collage left-side">
                      {/* Left Column: Stack of two horizontal cards */}
                      <div className="collage-column stack-column">
                        <div
                          className="collage-card small-card"
                          style={{ backgroundImage: `url(/assets/images/gallery/${smallImg})` }}
                        />
                        <div
                          className="collage-card horizontal-card"
                          style={{ backgroundImage: `url(/assets/images/gallery/${bottomImg})` }}
                        />
                      </div>
                      {/* Right Column: Tall vertical card */}
                      <div className="collage-column vertical-column">
                        <div
                          className="collage-card vertical-card"
                          style={{ backgroundImage: `url(/assets/images/gallery/${verticalImg})` }}
                        />
                      </div>
                    </div>

                    {/* Center Active Image */}
                    <div
                      className="gallery-center-active"
                      style={{ backgroundImage: `url(/assets/images/gallery/${centerImg})` }}
                    />

                    {/* Right Collage */}
                    <div className="gallery-side-collage right-side">
                      {/* Left Column: Tall vertical card */}
                      <div className="collage-column vertical-column">
                        <div
                          className="collage-card vertical-card"
                          style={{ backgroundImage: `url(/assets/images/gallery/${verticalImg})` }}
                        />
                      </div>
                      {/* Right Column: Stack of two horizontal cards */}
                      <div className="collage-column stack-column">
                        <div
                          className="collage-card small-card"
                          style={{ backgroundImage: `url(/assets/images/gallery/${smallImg})` }}
                        />
                        <div
                          className="collage-card horizontal-card"
                          style={{ backgroundImage: `url(/assets/images/gallery/${bottomImg})` }}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  /* Mobile Layout: Single Card Slider */
                  <div className="gallery-slide-layout-mobile">
                    <div
                      className="gallery-center-active-mobile"
                      style={{ backgroundImage: `url(/assets/images/gallery/${centerImg})` }}
                    />
                  </div>
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}

export default C2wTour;
